import { SpAlert } from '../../../../../components/sp-alert/sp-alert.model';

export class Controller {

    /** @ngInject */
    constructor($state, DropboxProvisioningService) {
        this.$state = $state;
        this.DropboxProvisioningService = DropboxProvisioningService;
    }

    $onInit() {
        this.applicationName = this.resolve.applicationName;
        this.dropboxProvisioningMappings = this.resolve.dropboxProvisioningMappings;
        this.groupMapping = this.resolve.groupMapping;
        this.spGroups = this.resolve.saaspassGroups;

        this.createProvisioningMapping = false;
        this.disableCreateProv = false;
        this.isFullSyncEnabled = false;
        this.selectedGroupId = '0';
        this.groupName = this.groupMapping.dropboxGroup.groupName;

        this.queryTypes = this.queryTypes.bind(this);

        this.disableEnableCreateProv();
    }

    disableEnableCreateProv() {
        this.disableCreateProv = this.selectedGroupId !== '0'
            && !!this.dropboxProvisioningMappings
                .find((mapping) => mapping.saaspassGroup.id === this.selectedGroupId);

        if (this.disableCreateProv) {
            this.createProvisioningMapping = false;
        }
    }

    queryTypes(group) {
        return group.type === 'CUSTOM'
            || group.type === 'APPLICATION' && group.groupName === this.applicationName;
    }

    save() {
        const companyId = this.$state.params.companyId;
        const appId = this.$state.params.appId;
        const newMapping = {
            groupId: this.selectedGroupId,
            groupMapping: {
                ...this.groupMapping,
                isFullSyncEnabled: this.isFullSyncEnabled,
            },
            createProvisioning: this.createProvisioningMapping,
            createNewGroup: this.selectedGroupId === '0',
        };

        this.DropboxProvisioningService.syncMapping
            .save({companyId, appId}, newMapping).$promise
            .then((data) => {
                this.close({
                    $value: {
                        response: data,
                        createProvMapping: this.createProvisioningMapping,
                    },
                });
            })
            .catch((error) => this.spAlert = new SpAlert('danger', error.data.message));
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/manage-application/dropbox-provisioning/dropbox-sync-mapping/dropbox-sync-mapping.controller.js